import { getCurrentLocale } from '../../common/utils/cookies';

export const getLocaleMapping = (): string => {
  const locale = getCurrentLocale();
  const lang = locale.split('_')[0].toLocaleLowerCase();
  return lang;
};
